export default __webpack_public_path__ + "static/room_b.588eb7dc3e3d3c536833ca800c0a8b69.svg";